import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import Store from './store';
import App from './App';
import './styles/index.scss';
import history from './utils/history';
import ScrollToTop from './utils/RouteHelper';
import { Router } from 'react-router-dom';
import config from "./utils/awsConfig";

import AppContext from '@context';

const MODEL_JSON = require('./model/consultaSoat.model.json');

localStorage.setItem("environment",'DEV');
config.amplifyConfig();

ReactDOM.render(
    <AppContext.Provider value={MODEL_JSON}>
        <Provider store={Store}>
            <Router history={history}>
                <ScrollToTop>
                    <App />
                </ScrollToTop>
            </Router>
        </Provider>
    </AppContext.Provider>,
    document.getElementById('root')
);
